import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import {PAGEACTIVITY } from './../constants/actionType'
import { InHomeUtils } from './../util/inhomeUtils'
import { store } from './../index';

let oldPage = null, newPage = null, newPageApiFetched = null;
const PageLoad ='PageLoad', ApiLoad ='ApiLoad', ApiTiming = 'ApiTiming', logUrl = apiUrl().kafkaPageLogs;
let pgLoggerObj = '';
const IH_APP_LOGS = 'applogs';
const IH_PAGE_LOGS = 'pagelogs'
let enableNodePageLogs = "N";

export const logKafka = (logType, logSubType, logMessage, logUrl, logName, visitid, blockType) => {
    if(window && window.location && window.location.pathname && !window.location.pathname.includes("/lbo")){
    let kafkaErrorMessage = "";
    let enableUIKibanaLogs = "Y";
    let SkipApitimingPagelogs = "N";
    if ((logType === 'ERROR' || logType === 'LBO' || logType === 'INFO' ) && blockType != "try") {
        let logObj = logMessage
        // for visit id undefine testing 
        if(logType === 'ERROR' && store.getState()?.loopQual && store.getState()?.loopQual?.runtimeKey  && store.getState()?.loopQual?.runtimeKey?.logsFlag?.toUpperCase() === 'Y'){
            logObj =  {
                "level": logType,
                 "message": JSON.stringify( {
                    logType: 'standardized_logs',
                    logSubType : 'UI_Error',
                    pageName: logSubType,
                    errorMessage: logMessage,
                    visit_id:  visitid  
                 }
                )       
            }
        }
        logToKibanna(logObj, logType)
    }
    if (logName === IH_APP_LOGS) {
        kafkaErrorMessage = { "logtype": logType, "logsubtype": logSubType, "lastupdated": new Date().toUTCString(), "logmessage": logMessage };
    }
    else if (logName === IH_PAGE_LOGS) {
        kafkaErrorMessage = logMessage;
        enableUIKibanaLogs = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.EnableUIKibanaLogs;
    }  

    enableNodePageLogs = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.EnableNodePageLogs;

    if(enableNodePageLogs === 'Y') {
        if(logUrl.indexOf("/atom_pagelogs") > -1) logUrl = apiUrl().kafkaPageLogsUrl;
        else if(logUrl.indexOf("/atom_applogs") > -1) logUrl = apiUrl().kafkaAppLogsUrl;
        logUrl = window.location.host.indexOf("localhost") > -1 ? window.location.origin + logUrl : logUrl;
    }

    SkipApitimingPagelogs = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.SkipApitimingPagelogs;

    if(SkipApitimingPagelogs === 'Y' && kafkaErrorMessage && kafkaErrorMessage.action && kafkaErrorMessage.action === ApiTiming && kafkaErrorMessage.pagename && kafkaErrorMessage.pagename !== 'LBO') {
        return;
    }

    const logs = getLogMessage(logName, kafkaErrorMessage, visitid);
    if (visitid && window.localStorage.getItem("visitor_id")) {
        if(enableUIKibanaLogs !== 'N') api(logUrl, 'POST', logs, 'text/plain');
    }
    else if (visitid && InHomeUtils.isNotNull(logSubType) && logSubType === PAGEACTIVITY.PAGE.FIFTENG) {        
        if(enableUIKibanaLogs !== 'N') api(logUrl, 'POST', logs, 'text/plain');
    }
    }
} 

export const logToKibanna = (data, type) => {
    let logmsg = data ? data + " JS_NOTIFY" : "";
    try {
      let KibanaLogMessage = {
        "level": type ? type : 'ERROR',
        "message": logmsg ? logmsg : ''
    };
    if(type === 'ERROR' && store.getState().loopQual && store.getState().loopQual.runtimeKey  && store.getState().loopQual.runtimeKey.logsFlag.toUpperCase() === 'Y'){
        KibanaLogMessage  = data 
    }
    enableNodePageLogs = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.EnableNodePageLogs;
    const url = (enableNodePageLogs === 'Y') ? apiUrl().logmsgUrl :apiUrl().jsNotify;
      return new Promise((resolve, reject) => {
        api(url, 'POST', KibanaLogMessage, 'application/json').then((response) => {
          const logResponse = response.data ? response.data : {};
          resolve(logResponse);
        }).catch((error) => {
          resolve(error);
        });
      });
    } catch (ex) {
      console.log(ex)
    }
  };



export const getPgLoggerObj = (obj) =>{

    if(InHomeUtils.isNotNull(obj.enableApiTiming) && obj.enableApiTiming)
        pgLoggerObj += 'ApiTiming';
    if(InHomeUtils.isNotNull(obj.enablePageLoad) && obj.enablePageLoad)
        pgLoggerObj += ',PageLoad';
    if(InHomeUtils.isNotNull(obj.enableUserAction) && obj.enableUserAction)
        pgLoggerObj += ',USERACTION';

    if(pgLoggerObj !== "")
        pgLoggerObj = pgLoggerObj.replace(/^,|,$/g,'');   

}  

function getLogMessage(topic,objectList,visitid){    
    var log = topic + '||visitid=' + visitid;
        // if (topic === 'pagelogs') {                 
        //     log = log + '||prvpagename=prevpage_name';
        // }
        for (var key in objectList) {
            log = log + '||' + key + '=' + objectList[key];
        }
        if (topic === IH_APP_LOGS) {
            log = log + '||logsource=UI';
        }
        return log;
 }

export const checktime = (pageDetails) => {
    pageDetails.mount &&( newPage = pageDetails);
    // (oldPage || (oldPage = pageDetails) ) &&
    pageDetails.unmount &&( oldPage = pageDetails);
    pageDetails.apiFetched && (newPageApiFetched = pageDetails);
   ( pageDetails.mount && newPage && oldPage  &&  (newPage.mount > oldPage.unmount)) && (() => {
        logPageInfo(pageInfo(PageLoad, newPage.mount-oldPage.unmount));
    })();
   ( pageDetails.apiFetched && newPage && newPageApiFetched  &&  (newPageApiFetched.apiFetched > newPage.mount)) && (() => {
      logPageInfo(pageInfo(ApiLoad, newPageApiFetched.apiFetched - newPage.mount));

   })();
 }
 
 export const updateVisitId = (visitid) => {
     visitid && (oldPage = Object.assign({}, oldPage ,{visitid: visitid}));
 }
 export const logApiTime = (api) => {
   //(api.url.indexOf('/kafka') === -1) && (api.url.indexOf('localhost') === -1) && logPageInfo(pageInfo(ApiTiming, api.time, api));
     (api.url.indexOf('localhost') === -1) && logPageInfo(pageInfo(ApiTiming, api.time, api)) || (api.pathName === '/proxy' && (JSON.parse(api.requestData).RequestUrl.indexOf('kafka') === -1) && logPageInfo(pageInfo(ApiTiming, api.time, api) ));
 }

 export const pageInfo = (pageAction, time, apiRes) => {
    return  {
       previousPage : oldPage.page,
       currentPage : newPage.page,
       pageUrl : apiRes && apiRes.url  || newPage.pageURL,
       action : pageAction,
       time :  time,
       reqData : apiRes && apiRes.requestData || 'component Load',
       noSSNCheck : newPage.noSSNCheck || false,
       visitid : newPage.visitid,
       pageSubname: apiRes && apiRes.pathName  && (apiRes.pathName +'_' + new Date().getTime()) ||( newPage.page+'_' + new Date().getTime())
   }
}

 export const logPageInfo = ( pageInfo) => {
    let pagejsoninfo = {info: pageInfo.noSSNCheck && "NO_SSN" || pageInfo.reqData};    
  
    // let loadTime = window.performance.timing.loadEventEnd - window.performance.timing.responseEnd;
    let kafkaPageMessage = {
        "prvpagename": pageInfo.previousPage || 'prevpage_name',//(appState.prevPage && appState.prevPage.pathname  )|| 'prevpage_name',
        "pagename": pageInfo.currentPage, //appState.currentPage.pathname,
        "pagesubname": pageInfo.pageSubname, //appState.currentPage.pathname,
        "pageurl":  pageInfo.pageUrl, //window.location.href,
        "action": pageInfo.action,//"PageLoad",
        "duration": Math.floor(pageInfo.time),
        "tsp": pageInfo.time,        
        "pagejson": JSON.stringify(pagejsoninfo),
        "lastupdated": getTimeInEST()
    };
    
    //resumecart page logging
    let enableResumeCartLog = true;
    if(window?.sessionStorage?.getItem('enableResumeCartLog') == 'true') {
        enableResumeCartLog = false;
    }

    if(!(pageInfo.currentPage === 'resumecart'))
    {
        logKafka('PAGE', pageInfo.currentPage, kafkaPageMessage, logUrl, 'pagelogs', pageInfo.visitid);
    }
    if(pageInfo.currentPage === 'resumecart')
    {
        if(enableResumeCartLog){
            logKafka('PAGE', pageInfo.currentPage, kafkaPageMessage, logUrl, 'pagelogs', pageInfo.visitid);
        }
    }

    //logKafka('PAGE', pageInfo.currentPage, kafkaPageMessage, logUrl, 'pagelogs', pageInfo.visitid);
}

export const logOtherInfo = (otherInfo) =>{
    if(window && window.location && window.location.pathname && !window.location.pathname.includes("/lbo")){

    let kafkaPageMessage = {       
        "pagename": otherInfo.pageName, 
        "pagesubname": otherInfo.pageSubname + '_' + new Date().getTime(),        
        "action": otherInfo.action,//"PageLoad",        
        "tsp": otherInfo.time, 
        "lastupdated": getTimeInEST(),
        "pagejson": otherInfo.message,
        "duration":0
    };

    //RETRIEVECART page logs disabling using AEM/Query Parameter
    let enableResumeCartLog = true;
    if(window?.sessionStorage?.getItem('enableResumeCartLog') == 'true') {
        enableResumeCartLog = false;
    }

    if(InHomeUtils.isNotNull(otherInfo) && InHomeUtils.isNotNull(otherInfo.action) && InHomeUtils.isNotNull(pgLoggerObj) && (pgLoggerObj.indexOf(otherInfo.action) > -1) && !(otherInfo.pageName === 'RETRIEVECART' || otherInfo.pageName === 'BUILDPRODUCT'))
    {
        logKafka('PAGE', otherInfo.pageName, kafkaPageMessage, logUrl, 'pagelogs', otherInfo.visitid);
    }
    if(InHomeUtils.isNotNull(otherInfo) && InHomeUtils.isNotNull(otherInfo.action) && InHomeUtils.isNotNull(pgLoggerObj) && (pgLoggerObj.indexOf(otherInfo.action) > -1) && (otherInfo.pageName === 'RETRIEVECART' || otherInfo.pageName === 'BUILDPRODUCT' ))
    {
        if(enableResumeCartLog){
            logKafka('PAGE', otherInfo.pageName, kafkaPageMessage, logUrl, 'pagelogs', otherInfo.visitid);
        }
    }
    }

}
    

export const detailsInfo = (pageName,visitid,pageSubname,logMsg,actionType=null) =>{
    return  { 
        pageName:pageName,
        action : (actionType === PAGEACTIVITY.UA) ? PAGEACTIVITY.UA : "pageAction",
        time :  new Date().toUTCString(),               
        visitid : visitid,
        pageSubname:pageSubname,
        message:logMsg
    }
}

const getTimeInEST = () => {
    const date = new Date();
    let fullEstTime = getEstTime(date);
    // console.log('fullEstTime', fullEstTime);
    let arrDtTime , time , strDate ,
     arrTime , arrDate , year, month, day, hour, minute, second = null;
     let nbrHr = 0;
    
     if(fullEstTime.indexOf(',') > -1 ) {
         arrDtTime =  fullEstTime.split(','); // ["4/1/2020", " 2:44:43 PM"]
         time = arrDtTime[1].trim().split(' '); //["2:44:43", "PM"]
         strDate = arrDtTime[0].trim();
         nbrHr = time[1] === 'PM' ? 12 : 0;
         arrTime = time[0].split(':');
         arrDate = arrDtTime[0].trim().split('/');
         year = arrDate[2], month = arrDate[0], day = arrDate[1],
         hour = arrTime[0], minute = arrTime[1] , second = arrTime[2];

     } else {
        //  console.log('fullEstTime else fullEstTime', fullEstTime);
         const ieTime = fullEstTime.trim().split(' ');
         time = ieTime[1].trim().split(' '); //["2:44:43", "PM"]
         strDate = ieTime[0].trim();
         nbrHr = ieTime[2].trim() === 'PM' ? 12 : 0;
         arrTime = ieTime[1].split(':');
         arrDate = ieTime[0].trim().split('/');
         year = cleanString (arrDate[2]), month = cleanString(arrDate[0]), day = cleanString(arrDate[1]),
         hour = cleanString(arrTime[0]), minute = cleanString(arrTime[1]) , second = cleanString(arrTime[2]);
     }
    hour = padZeroInTheStart(JSON.stringify(parseInt(hour.trim()) + nbrHr));
    minute = padZeroInTheStart ( minute) ;
    second = padZeroInTheStart ( second) ;
    month = padZeroInTheStart ( month) ;
    day = padZeroInTheStart ( day)  ;
    const estTimeFormat = [hour,minute,second].join(':')
    const estDateFormat = [year,month, day].join('-');
    const timeString = estDateFormat + ' '+
                       estTimeFormat + '.'+
                       date.getMilliseconds();
    //  console.log('fullEstTime timeString', timeString);
     return timeString;
}

const padZeroInTheStart = (time) => {
    return time.length === 2 ? time : '0'+time;
}
const cleanString = (str) => {
    return str.replace(/[^0-9/]/ig, "");
}

const getEstTime = (dateIn) => {
    
    try {
        return dateIn.toLocaleString("en-US", {timeZone: "America/New_York"});
    } catch (ex) {
        if (!(dateIn instanceof Date)) {
            console.error(ex);
        } else {
            // For non-modern browsers without locale and timeZone support (<=IE11, <Safari10, etc...)
            try {                
                let dNowUTC = new Date(dateIn.getUTCFullYear(), dateIn.getUTCMonth(), dateIn.getUTCDate(), dateIn.getUTCHours(), dateIn.getUTCMinutes(), dateIn.getUTCSeconds());
                let estOffset = getEstOffsetFromUTC(dateIn) * 3600 * 1000;
                let estDate = new Date(dNowUTC - estOffset);
                
                let estDay = (estDate.getMonth()+1 + "/" + estDate.getDate() + "/" + estDate.getFullYear());
                let estHours = estDate.getHours();
                let amPm = estHours > 12 ? 'PM' : 'AM';
                estHours = (estHours === 0) ? 12 : estHours % 12;
                
                let estMinutes = padZero(estDate.getMinutes());                
                let estSeconds = padZero(estDate.getSeconds());                
                let estTime = (estHours + ":" + estMinutes + ":" + estSeconds);
                
                return (estDay + ", " + estTime + " " + amPm);

                function getEstOffsetFromUTC(aDate) {
                    const aDateFullYear = aDate.getFullYear();
                    const jan = new Date(aDateFullYear, 0, 1);
                    const jul = new Date(aDateFullYear, 6, 1);
                
                    if (aDate.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())) {
                        return 4;
                    } else {
                        return 5;
                    }
                }
    
                function padZero(val) {
                    return (val < 10) ? ("0"+val) : val;
                }
            } catch (ex) {
                console.error(ex);
            }
        }
    }

}
export const updatePageLogs = (appState, visitid, noSSNCheck) => {
    let pagejsoninfo = {};
    //let logUrl = apiUrl().kafkaPageLogs;
    pagejsoninfo.info = "info";
    if (noSSNCheck) {
        pagejsoninfo.info = "NO_SSN";
    }
    let loadTime = window.performance.timing.loadEventEnd - window.performance.timing.responseEnd;
    let kafkaPageMessage = {
        "prvpagename": (appState.prevPage && appState.prevPage.pathname) || 'prevpage_name',
        "pagename": appState.currentPage.pathname,
        "pagesubname": appState.currentPage.pathname + '_' + new Date().getTime(),
        "pageurl": window.location.href,
        "action": "PageLoad",
        "duration": Math.floor(loadTime),
        "tsp": loadTime,
        "pagejson": JSON.stringify(pagejsoninfo),
        "lastupdated": getTimeInEST()
    };

   //logKafka('PAGE', appState.currentPage.pathname, kafkaPageMessage, logUrl, 'pagelogs', visitid);
}

export const catchJSException = (pageName, visitid, pageSubname, error) =>{

    let errMsg = "";
    console.error(error);
    if (InHomeUtils.isNotNull(error)) {
        if (InHomeUtils.isNotNull(error.stack) && error.stack !== "") {
            errMsg = error.stack;
        }
        else if (InHomeUtils.isNotNull(error.message) && error.message !== "") {
            errMsg = error.message + ": js error in " + pageName + " in " + pageSubname;
        }
        else {
            errMsg = "js error in " + pageName + " in " + pageSubname;
        }
    }

    let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
    logKafka("JSERROR", pageName + "_" + pageSubname, errMsg, getErrorLogUrl, IH_APP_LOGS, visitid);
}

export const errCheck = (obj) => {
    return (obj !== undefined && obj !== null)
}